module.exports = __webpack_public_path__ + "static/media/comment-alt-dollar.635fb5da.svg";